import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CircularIndicator from '../indicators/circularIndicator';
import TagsDisplay from '../driver/tagsDisplay';

const largeText = (text, obj) => {
  let textAux = `${text}  `;
  if (text.length > 22) {
    textAux = `${text.substring(0, 22)} ... `
  }
  return (
    <div className="info-name">
      {textAux}
      <section className="help-component ranking-old">
        <section className="box-help">
          <i className="fas fa-eye" />
          <section className="box plus">
            <h3>{text}</h3>
            <TagsDisplay language={obj.language} filter={obj.filter} tags={obj.tags} />
          </section>
        </section>
      </section>
    </div>
  );
};

class RankingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 10,
      loadingPage: false
    }
  }

  handleScroll = async event => {
    if (this.props.data && this.props.data.length>0 && 
      this.state.page < (this.props.data.length/this.state.pageSize) && 
      !this.state.loadingPage) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight - 20;
      if (scroll >= max) {
        this.state.loadingPage = true;
        this.setState({ loadingPage: true });        
        setTimeout(() => { 
          this.setState({ page: this.state.page + 1, loadingPage: false });
        }, 500);
      }
    } 
  };

  render() {
    return (
      <section className="ranking-table" onScroll={this.handleScroll}>
        <table>
          <thead>
            <tr>
              <th className="ranking-table-th ranking-th center"></th>
              <th className="ranking-table-th info-th"></th>
              <th className="ranking-table-th value-th"></th>
            </tr>
          </thead>
          <tbody>
            {this.props.data &&
              this.props.data.map((item, i) => {
                if(i>=this.state.page*this.state.pageSize) {
                  return null
                }
                return (
                  <tr
                    onClick={this.props.link}
                    data-driveralias={item[this.props.nameColumn]}
                    data-driverid={item.driverId}
                    key={`t-ranking-table-${i}`}
                  >
                    <td className="ranking-table-td ranking-td">{item.ranking}</td>
                    <td className="ranking-table-td info-td">
                      {largeText(item[this.props.nameColumn], {
                        language: this.props.language,
                        filter: this.props.filter,
                        tags: item.tags
                      })}
                      <TagsDisplay
                        max={true}
                        language={this.props.language}
                        filter={this.props.filter}
                        tags={item.tags}
                      />
                    </td>
                    <td className="ranking-table-td value-td">
                      <CircularIndicator
                        id={i}
                        size={65}
                        max={100}
                        value={item[this.props.kpiColumn]}
                        fontSize={'15px'}
                        thickness={5}
                        valueFormat={{
                          type: 'NUMBER',
                          format: this.props.kpiFormat ? this.props.kpiFormat : '.0f'
                        }}
                        graphColorRange={this.props.graphColorRange}
                      />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
        {this.state.loadingPage && (
          <div className="loading-table">
            <h6>
              <i className="fas fa-spinner fa-spin" />
            </h6>
          </div>
        )}
      </section>
    );
  }
}

export default RankingTable;



// WEBPACK FOOTER //
// ./source/client/components/common/tables/rankingTable.jsx